import { useQuery } from "@tanstack/react-query";
import { socialApi } from "@bw/shared/api";
import type { FriendRequestsResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * The caller's pending friend-request inbox (GET /social/friends/requests),
 * returned VERBATIM as { incoming, outgoing } — each a list of FriendRequestItem
 * ({friendship_id, user_id, display_name, avatar_url, created_at}). `user_id` is
 * always the OTHER party (the sender for incoming, the recipient for outgoing);
 * the page renders display_name (never the raw uid / friendship_id). The server
 * scopes the inbox to the token user, so the cache key carries no uid.
 *
 * Cached under the `social.friend-requests` key; accept / decline / cancel
 * mutations invalidate it to refetch the server's truth — see useFriendActions.
 * No client sort, no derived state.
 */
export function useFriendRequests() {
  return useQuery<FriendRequestsResponse>({
    queryKey: queryKeys.social.friendRequests(),
    queryFn: () => socialApi.getFriendRequests(),
  });
}
